import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../lib/auth';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { toast } from '../lib/aiToast';
import { ArrowRight, Bot } from 'lucide-react';

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState('sarah@pacificderm.com');
  const [password, setPassword] = useState('demo1234');
  const [submitting, setSubmitting] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      await login(email, password);
      toast.success('Welcome back');
      nav('/app');
    } catch (err) {
      toast.error(err.message);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen grid md:grid-cols-2">
      <div className="hidden md:flex dh-hero p-12 flex-col justify-between">
        <Link to="/" className="flex items-center gap-2">
          <div className="h-8 w-8 rounded-lg bg-brand-600 text-white flex items-center justify-center font-bold">D</div>
          <div className="leading-tight">
            <div className="text-sm font-semibold text-slate-900">Due Health</div>
            <div className="text-[10px] uppercase tracking-wider text-brand-500 font-medium">Eligibility AI</div>
          </div>
        </Link>
        <div>
          <div className="inline-flex items-center gap-1.5 text-xs text-violet-700 bg-violet-50 border border-violet-200 px-2.5 py-1 rounded-full"><Bot className="h-3.5 w-3.5" />7 agents working your worklist</div>
          <h2 className="mt-4 text-3xl font-semibold text-slate-900 max-w-md">Your front desk, on autopilot.</h2>
          <p className="mt-3 text-slate-600 max-w-md">Agents verify eligibility, score risk, and draft the next step. You review only the exceptions.</p>
        </div>
        <div className="text-xs text-slate-500">© 2026 Due HealthTech · HIPAA-eligible</div>
      </div>

      <div className="p-8 md:p-12 flex items-center justify-center bg-white">
        <div className="w-full max-w-sm">
          <h1 className="text-2xl font-semibold text-slate-900">Sign in</h1>
          <p className="mt-1 text-sm text-slate-500">Use the demo workspace, or your account.</p>
          <form onSubmit={submit} className="mt-8 space-y-4">
            <div><Label htmlFor="email">Email</Label><Input id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required className="mt-1.5" /></div>
            <div><Label htmlFor="pw">Password</Label><Input id="pw" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required className="mt-1.5" /></div>
            <Button type="submit" className="w-full bg-brand-600 hover:bg-brand-700 text-white" disabled={submitting}>
              {submitting ? 'Signing in…' : <>Sign in <ArrowRight className="h-4 w-4 ml-1" /></>}
            </Button>
          </form>
          <div className="mt-6 dh-inset p-3 text-xs text-slate-600">
            <div className="font-medium text-slate-800">Demo accounts</div>
            <div className="mt-1">sarah@pacificderm.com (front desk) · mike@ (billing) · aravind@ (manager) · admin@duehealth.com (admin) — all use <span className="mono">demo1234</span></div>
          </div>
          <div className="mt-6 text-sm text-slate-600 text-center">
            New practice? <Link to="/register" className="text-brand-600 font-medium hover:underline">Create workspace</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
